var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToastSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.02 5.313a.5.5 0 0 1 0 .707l-4.666 4.667a.5.5 0 0 1-.708 0L3.98 8.02a.5.5 0 1 1 .707-.707L7 9.626l4.313-4.313a.5.5 0 0 1 .707 0"
})));
export default SvgToastSuccess;